import { Ok } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import type { ConsentService } from '@core/model/service/consentService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type SendConsentInput = {
  userToken: string;
  userId: string;
  hasConsented: boolean;
  termsVersion: string;
  cguVersion: string;
};
export type SendConsentOutput = Promise<Ok>;

@injectable()
export class SendConsent implements Usecase<SendConsentInput, SendConsentOutput> {
  constructor(
    @inject(SERVICE_ID.consentService)
    private readonly consentService: ConsentService
  ) {}

  async execute(cmd: SendConsentInput): SendConsentOutput {
    return this.consentService.sendConsent(cmd);
  }
}
